import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47afb5e9&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContextAdditions: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/ContextAdditions/index.vue').default,SocialVideoFrameComponent: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/SocialVideoFrameComponent/index.vue').default,AudioPlayer: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/AudioPlayer/index.vue').default,ScheduleCalendar: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/ScheduleCalendar/index.vue').default,HorizontalEntityCard: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/HorizontalEntityCard/index.vue').default,PlaceCard: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/PlaceCard/index.vue').default,Scroller: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Scroller/index.vue').default,PhotoSign: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/PhotoSign/index.vue').default,Brochure: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Brochure/index.vue').default,EntityContent: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/EntityContent/index.vue').default,Section: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/Section/index.vue').default})
